
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#1B2530","stroke-width":"1.326","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.989 5.037a3.977 3.977 0 107.954 0 3.977 3.977 0 00-7.954 0h0z"}}),_c('path',{attrs:{"d":"M16.966 3.048v1.989h1.326M4.04 4.705a2.32 2.32 0 104.64 0 2.32 2.32 0 00-4.64 0h0zM13.136 20.938a1.326 1.326 0 01-1.465-1.17l-.336-3.005a1.317 1.317 0 00-1.309-1.123h-1.88a2.645 2.645 0 01-2.616-2.214l-.477-2.868a1.326 1.326 0 112.614-.435l.478 2.87h1.883a3.956 3.956 0 013.95 3.54l.33 2.944a1.326 1.326 0 01-1.172 1.46zM1.057 20.946h7.187a.796.796 0 00.796-.884l-.12-1.077a.775.775 0 00-.771-.69 5.29 5.29 0 01-5.23-4.427l-.292-1.756A1.326 1.326 0 001.315 11h-.258"}})])])
          )
        }
      }
    